<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">domain</v-icon>
      Locations
      <template slot="buttons">
        <v-btn :to="{ name: 'clientBusinessNew' }" color="success">
          <v-icon left>
            add
          </v-icon>
          Add Location
        </v-btn>
      </template>
    </HeaderBar>

    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="filteredClientBusinesses"
            item-key="id"
            :search="search"
            :pagination.sync="defaultSort"
            class="elevation-1"
            :loading="gettingLocations"
          >
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>
                  <router-link
                    :to="{
                      name: 'clientBusinessDetail',
                      params: { clientBusinessId: item.id }
                    }"
                    class="unstyled-link"
                    target="_blank"
                  >
                    <v-icon>launch</v-icon>
                  </router-link>
                </td>
                <td @click="openClientBusiness(item)">{{ item.name }}</td>
                <td @click="openClientBusiness(item)">
                  <v-chip v-for="l in locationNames(item)">{{ l }}</v-chip>
                </td>
                <td>{{ item.fulfillment_stats.shifts_ordered }}</td>
                <td>{{ item.fulfillment_stats.shifts_filled }}</td>
                <td>
                  {{ Math.round(item.fulfillment_stats.fulfillment_rate) }}%
                </td>
                <!-- <td>{{ item.contractDate | moment("MM/DD/YY") }}</td> -->
              </tr>
            </template>
          </v-data-table>

          <v-layout row align-center justify-space-around class="px-2 py-1">
            <v-flex shrink class="mr-1">
              <v-switch
                label="View All Locations"
                v-model="viewingAllLocations"
              >
              </v-switch>
            </v-flex>

            <v-flex shrink class="mr-1">
              <v-autocomplete
                v-model="selectedManagerFilter"
                item-text="name"
                return-object
                :items="filterableManagers"
                label="By Manager"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-select
                label="State"
                :items="filterableStates"
                item-value="name"
                item-key="name"
                v-model="selectedStateFilter"
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmployeeName from "@/components/hr/employee-name.vue";
import HeaderBar from "@/components/base/header-bar.vue";
import collectionsApi from "@/api/collections";

export default {
  components: {
    EmployeeName,
    HeaderBar
  },
  created() {
    this.setUp();
  },
  watch: {
    viewingAllLocations: "resetManagerFilter"
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    ...mapState("clientBusinesses", ["clientBusinesses"]),
    ...mapState("hr", ["filters"]),
    filteredClientBusinesses: function() {
      var filtered = this.clientBusinesses;

      if (this.selectedManagerFilter) {
        filtered = filtered.filter(business => {
          if (
            business.locations
              .map(l => l.managerId)
              .includes(this.selectedManagerFilter.id)
          ) {
            return business;
          }
        });
      }

      if (this.selectedStateFilter) {
        filtered = filtered.filter(business => {
          if (
            business.locations
              .map(l => l.state)
              .includes(this.selectedStateFilter)
          ) {
            return business;
          }
        });
      }

      return filtered;
    },
    filterableStates: function() {
      return [
        ...new Set(
          this.clientBusinesses
            .flatMap(business => business.locations.map(loc => loc.state))
            .filter(state => state && state.trim() !== "")
        )
      ].sort();
    }
  },
  methods: {
    locationNames(business) {
      return business.locations.map(l => l.name);
      // TODO: if they don't want to see redundant names:
      //if (business.locations.count > 1 || business.locations[0].name != business.name) {
      //return business.locations.map((l) => l.name ).join(", ")
      //} else {
      //return ""
      //}
    },

    resetFilters() {},

    openClientBusiness(clientBusiness) {
      this.$router.push({
        name: "clientBusinessDetail",
        params: { clientBusinessId: clientBusiness.id }
      });
    },
    setUp() {
      this.$store.dispatch("clientBusinesses/getAll", this.user.id).then(r => {
        this.gettingLocations = false;
      });

      collectionsApi.getManagersList({}, managers => {
        this.filterableManagers = managers.concat([
          { id: null, name: "No Manager" }
        ]);

        this.setManagerFilterToMe();
      });
    },
    setManagerFilterToMe() {
      this.selectedManagerFilter = this.filterableManagers.find(
        m => m.id == this.user.id
      );
    },
    setViewingAll() {
      if (!this.selectedManagerFilter) {
        this.viewingAllLocations = true;
      } else {
        this.viewingAllLocations = false;
      }
    },
    resetManagerFilter() {
      if (this.viewingAllLocations) {
        this.selectedManagerFilter = null;
      } else {
        this.setManagerFilterToMe();
      }
    }
  },
  data: function() {
    return {
      gettingLocations: true,
      viewingAllLocations: false,
      filterableManagers: [],
      selectedManagerFilter: null,
      selectedStateFilter: "",
      search: "",
      defaultSort: {
        sortBy: "name",
        ascending: true,
        rowsPerPage: 10
      },
      headers: [
        { text: "" },
        { text: "Name", value: "name" },
        { text: "Child Locations" },
        { text: "Shifts Ordered", value: "fulfillment_stats.shifts_ordered" },
        { text: "Shifts Filled", value: "fulfillment_stats.shifts_filled" },
        {
          text: "Fulfillment Rate",
          value: "fulfillment_stats.fulfillment_rate"
        },
        // { text: 'Contract Date', value: 'contractDate' },
        { text: "", value: "" }
      ],
      menuData: {
        messages: [
          "Any message you like can go here",
          "Will rotate through list of actual messages"
        ],
        employeeName: "Brad",
        hasMail: true,
        hasTasksDue: false
      }
    };
  }
};
</script>

<style scoped></style>
